// Provides a reusable modal dialog container consistent with the app's styling.
// Renders an overlay modal with an optional title and body content.
export default function DialogBox({
  open = false,
  title = '',
  onClose = () => {},
  children,
}) {
  if (!open) return null;

  // Close the dialog when the backdrop itself is clicked.
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4 py-6"
      onClick={handleBackdropClick}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title || 'Dialog'}
        className="relative w-full max-w-md text-left rounded-3xl border border-slate-200 bg-white p-6 text-slate-900 shadow-xl"
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 text-xl text-slate-400 transition hover:text-slate-600 focus:outline-none"
          aria-label="Close dialog"
        >
          ×
        </button>

        {title ? (
          <h2 className="pr-8 text-2xl font-semibold text-slate-900">
            {title}
          </h2>
        ) : null}

        <div className="mt-4 text-base text-slate-600">{children}</div>
      </div>
    </div>
  );
}
